import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import App from "../app";

const { recaptchaSiteKey } = window.asos.repairRequest.state;
delete window.asos.repairRequest.state;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <App recaptchaSiteKey={recaptchaSiteKey} />
    );
  });
};

start();
